var inScene = null;
var outScene = null;

function sceneScrollInit(){
    if(inScene !== null){
        outScene.destroy(true);
        inScene.destroy(true)
    }

    var gap = 0;
    $('.section-3-1 .scene-container .d-flex > div').each(function () {
        gap += $(this).innerWidth();
    });
    gap -= $('.section-3-1 .inner-pinned .scene-container').width();
    var offset = $('.section-3-1 .pinned').height() - ($(window).height()) + 100;

    if (gap > 0 && $(window).width() >= 768) {
        // horizontal scroll tween
        var section1_1Horizontal = new TimelineMax()
            .to(".section-3-1 .scene-container .d-flex", 1, {
                x: "-" + gap + "px"
            })

        // create scene to pin and link animation
        inScene = new ScrollMagic.Scene({
            offset        : offset,
            triggerElement: ".section-3-1 .pinned",
            triggerHook   : 0,
            duration      : $(window).height()*1.5
        })
            .setPin(".section-3-1 .pinned")
            .addTo(require('../scrollInit'));
        // create scene to pin and link animation

        outScene = new ScrollMagic.Scene({
            offset        : offset,
            triggerElement: ".section-3-1 .pinned",
            triggerHook   : 0,
            duration      : $(window).height()*1.5
        })
            .setTween(section1_1Horizontal)
            .addTo(require('../scrollInit'));
    }
    AOS.refresh();
}

function slickInit(){
    $('.section-3-1 .scene-container .d-flex').slick({
        dots       : true,
        mobileFirst: true,
        infinite   : false,
        arrows     : false,
        responsive : [
            {
                breakpoint: 767,
                settings  : "unslick"
            }
        ]
    });
}

$(function(){
    sceneScrollInit();
    slickInit();
    let resizedFinished;
    $(window).on('resize', function() {
        clearTimeout(resizedFinished);
        resizedFinished = setTimeout(function(){
            sceneScrollInit();
            slickInit();
        }, 250);
    });
    $('.section-3-1 video').each(function(){
        $(this)[0].play();
    });
})